import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "./i18n/I18nContext";
import { AuthProvider } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import DocumentTitle from "./components/DocumentTitle";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Properties from "./pages/Properties";
import PropertyDetail from "./pages/PropertyDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Inquiry from "./pages/Inquiry";
import Booking from "./pages/Booking";
import BookingTrack from "./pages/BookingTrack";
import CoutureTracking from "./pages/CoutureTracking";
import CoutureDocument from "./pages/CoutureDocument";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProperties from "./pages/admin/AdminProperties";
import AdminPropertyForm from "./pages/admin/AdminPropertyForm";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminBookings from "./pages/admin/AdminBookings";
import ProtectedAdminRoute from "./pages/admin/ProtectedAdminRoute";

import CoutureLogin from "./pages/couturier/CoutureLogin";
import CoutureDashboard from "./pages/couturier/CoutureDashboard";
import CoutureOrders from "./pages/couturier/CoutureOrders";
import CoutureOrderForm from "./pages/couturier/CoutureOrderForm";
import CoutureOrderDetail from "./pages/couturier/CoutureOrderDetail";
import CoutureCategories from "./pages/couturier/CoutureCategories";
import CoutureMeasurements from "./pages/couturier/CoutureMeasurements";
import CoutureSettings from "./pages/couturier/CoutureSettings";
import ProtectedCoutureRoute from "./pages/couturier/ProtectedCoutureRoute";

function App() {
    return (
        <div className="App">
            <I18nProvider>
                <AuthProvider>
                    <SiteProvider>
                        <DocumentTitle />
                        <BrowserRouter>
                            <Toaster position="top-right" richColors closeButton />
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/services" element={<Services />} />
                                <Route path="/biens" element={<Properties />} />
                                <Route path="/biens/:id" element={<PropertyDetail />} />
                                <Route path="/a-propos" element={<About />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/demande" element={<Inquiry />} />
                                <Route path="/reservation" element={<Booking />} />
                                <Route path="/reservation/suivi/:token" element={<BookingTrack />} />
                                <Route path="/couture" element={<CoutureTracking />} />
                                <Route path="/couture/suivi" element={<CoutureTracking />} />
                                <Route path="/couture/suivi/:code" element={<CoutureTracking />} />

                                <Route path="/couturier/login" element={<CoutureLogin />} />
                                <Route path="/couturier" element={<ProtectedCoutureRoute><CoutureDashboard /></ProtectedCoutureRoute>} />
                                <Route path="/couturier/commandes" element={<ProtectedCoutureRoute><CoutureOrders /></ProtectedCoutureRoute>} />
                                <Route path="/couturier/commandes/nouvelle" element={<ProtectedCoutureRoute><CoutureOrderForm /></ProtectedCoutureRoute>} />
                                <Route path="/couturier/commandes/:id" element={<ProtectedCoutureRoute><CoutureOrderDetail /></ProtectedCoutureRoute>} />
                                <Route path="/couturier/categories" element={<ProtectedCoutureRoute><CoutureCategories /></ProtectedCoutureRoute>} />
                                <Route path="/couturier/mesures" element={<ProtectedCoutureRoute><CoutureMeasurements /></ProtectedCoutureRoute>} />
                                <Route path="/couturier/parametres" element={<ProtectedCoutureRoute><CoutureSettings /></ProtectedCoutureRoute>} />
                                <Route path="/couturier/documents/:id" element={<ProtectedCoutureRoute><CoutureDocument /></ProtectedCoutureRoute>} />

                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
                                <Route path="/admin/inquiries" element={<ProtectedAdminRoute><AdminInquiries /></ProtectedAdminRoute>} />
                                <Route path="/admin/properties" element={<ProtectedAdminRoute><AdminProperties /></ProtectedAdminRoute>} />
                                <Route path="/admin/properties/new" element={<ProtectedAdminRoute><AdminPropertyForm /></ProtectedAdminRoute>} />
                                <Route path="/admin/properties/:id/edit" element={<ProtectedAdminRoute><AdminPropertyForm /></ProtectedAdminRoute>} />
                                <Route path="/admin/messages" element={<ProtectedAdminRoute><AdminMessages /></ProtectedAdminRoute>} />
                                <Route path="/admin/settings" element={<ProtectedAdminRoute><AdminSettings /></ProtectedAdminRoute>} />
                                <Route path="/admin/bookings" element={<ProtectedAdminRoute><AdminBookings /></ProtectedAdminRoute>} />
                            </Routes>
                        </BrowserRouter>
                    </SiteProvider>
                </AuthProvider>
            </I18nProvider>
        </div>
    );
}

export default App;
